<template>
  <div>
    <div
      class="d-inline-block shadow-light rounded-xl select-wraper"
      :class="cssClasses"
    >
      <div class="d-flex mx-auto justify-content-between align-items-center ">
        <div class="d-flex justify-content-center flex-grow-1">
          <b-dropdown
            toggle-class="p-0 toggle-button text-color2 d-flex align-items-center cursor-pointer"
            variant="none"
            menu-class="dropdown-default font-size-xSmall p-3 text-center"
            no-caret
            v-if="value"
          >
            <template v-slot:button-content>
              <template v-if="selectedIcon">
                <BaseIcon
                  :size="size"
                  v-if="selectedIcon === 'globe' || selectedIcon === 'lock'"
                  :style="iconStyle"
                >
                  <GlobeIcon v-if="selectedIcon === 'globe'" />
                  <LockIcon v-if="selectedIcon === 'lock'" />
                </BaseIcon>
                <i
                  class="mr-2"
                  :class="selectedIcon"
                  v-else
                ></i>
              </template>
              <span class="selected-option">
                {{ formatSelected }} <i class="fa fa-caret-down"></i>
              </span>
            </template>
            <template v-slot:default>
              <div
                v-for="(option, index) in options"
                :key="option.key"
              >
                <b-dropdown-item-button
                  button-class="select-option"
                  @click="select(option.key)"
                >
                  {{ option.value }}
                </b-dropdown-item-button>
                <hr class="h-1 background-color2" v-if="index < options.length - 1" />
              </div>
            </template>
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BaseIcon from '@/components/common/Icon/BaseIcon'
import GlobeIcon from '@/components/common/Icon/GlobeIcon'
import LockIcon from '@/components/common/Icon/LockIcon'

export default {
  name: 'DropdownSelect',
  props: ['value', 'options', 'size'],
  components: {
    BaseIcon,
    GlobeIcon,
    LockIcon
  },
  computed: {
    cssClasses () {
      return [
        this.size ? `size-${this.size}` : '',
        localStorage.getItem('nightMode') ? 'background-black' : 'background-white'
      ]
    },
    iconStyle () {
      const style = {}
      if (this.size === 'xSmall') style.marginTop = '-3px'
      return style
    },
    formatSelected () {
      const selected = this.options.find(obj => {
        return obj.key === this.value
      })
      return selected.value
    },
    selectedIcon () {
      const selected = this.options.find(obj => {
        return obj.key === this.value
      })
      return selected.icon
    }
  },
  methods: {
    select (key) {
      this.$emit('input', key)
      this.$emit('selected', key)
      this.$emit('change', key)
    }
  }
}
</script>

<style lang="scss" scoped>

.select-wraper {
  padding: 12px 24px 12px;
}

.selected-option {
  font-size: $font_size_small;
}

.size-xSmall {
  &.select-wraper {
    padding: 8px 24px 8px;
  }

  .selected-option {
    font-size: $font_size_xSmall;
  }
}

::v-deep .select-option {
  padding: 0;
  transition: all 0.2s ease-out;
  &:hover {
    background: transparent;
    color: $color2;
  }
  &:active {
    background: transparent;
    color: $color1;
  }
}

::v-deep {
  .toggle-button {
    color: $color2;

    &:hover {
      color: $color2;
    }
  }
}

</style>
